import { NgModule } from '@angular/core';
import { MwToolTipDirective } from './mw-tooltip.directive';
import { MwReadOnlyDirective } from './mw-read-only.directive';

@NgModule({
  declarations: [MwToolTipDirective, MwReadOnlyDirective],
  imports: [],
  exports: [MwToolTipDirective, MwReadOnlyDirective],
})
export class MwSharedDirectivesModule {}
